import { token } from "@may-i/mash-design-system";
import styled, { keyframes } from "styled-components";

export function PageSpinner() {
  return (
    <Container>
      <Spinner />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0;
`;

const spin = keyframes`
  100% { transform: rotate(1turn); }
`;

const SIZE = 32;
const THICKNESS = Math.max(2, SIZE * 0.16);

const Spinner = styled.div`
  width: ${SIZE}px;
  height: ${SIZE}px;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, ${token("colors.brand.MB500")} 94%, #0000)
      top / ${THICKNESS}px ${THICKNESS}px no-repeat,
    conic-gradient(#0000 30%, ${token("colors.brand.MB500")});
  mask: radial-gradient(
    farthest-side,
    #0000 calc(100% - ${THICKNESS}px),
    #000 0
  );
  animation: ${spin} 1s infinite linear;
`;
